import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations, firestoreAction } from 'vuexfire';
import { db } from '@/firebase';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    clients: [],
    statistiques: {},
  },
  mutations: vuexfireMutations,
  actions: {
    bindClientsRef: firestoreAction((context) => {
      return context.bindFirestoreRef('clients', db.collection('clients'));
    }),
    bindStatistiquesRef: firestoreAction((context) => {
      return context.bindFirestoreRef('statistiques', db.doc('statistiques/statistiques'));
    }),
  },
  modules: {},
});
